import { DeepPartial } from "../../types";
import { ChartAdapter } from "./chart";
import { ContextData, ReportContext } from "@reporting/rp-types/analytics";

export class DefaultChartAdapter implements ChartAdapter {

	constructor(
		/** recomputes the options so a refresh follows the current view options */
		private readonly createChartOptions: () => Highcharts.Options,
		readonly contextData: ContextData,
		/** report context of the rendered data, the drill down needs it */
		readonly reportContext?: ReportContext
	) { }

	get chartOptions(): Highcharts.Options {
		return this.createChartOptions();
	}

	getChart(): DeepPartial<Highcharts.Options> {
		return this.chartOptions;
	}

}
